/* eslint import/prefer-default-export:off */

const voca = v.noConflict();

function toString(value, precision = 0) {
    const p = _.toNumber(precision);
    let result = '';
    if (!_.isNaN(p) && p > 0) {
        result = voca.sprintf(`%.${p}f`, value);
    } else {
        result = voca.sprintf('%d', value);
    }
    return result;
}

export {
    toString,
};



// WEBPACK FOOTER //
// ./src/utils/ec-number.js